<template>
    <!-- Footer -->
    <footer class="footer bg-dark">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 h-100 text-center text-lg-left my-auto">
                    <p class="text-muted small mb-4 mb-lg-0">&copy; Traf City {{year}}. All Rights Reserved.</p>
                </div>
                <div class="col-lg-6 h-100 text-center text-lg-right my-auto">
                    <p class="text-muted small mb-4 mb-lg-0"><a href="/opt-out" class="text-warning"><u>Unsubscribe</u></a></p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data: function() {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>

<!-- Custom Styles -->
<style>

</style>
